<div
  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-px-12"
>
  @if (waiting) {
    <img
      src="/images/screen-sharing/screen-sharing-wait.png"
      width="60"
      height="60"
      class="tw-mb-8"
      alt="Waiting"
    />
    <div class="tw-font-bold tw-text-xl tw-py-5">
      Wait for the moderator to invite you to share
    </div>
  } @else if (screenSharingService.memberIsSharing) {
    @if (isPaused) {
      <img
        src="/images/screen-sharing/screen-sharing-paused.png"
        width="60"
        height="60"
        class="tw-mb-8"
        alt="Paused"
      />
      <strong class="tw-text-3xl tw-font-semibold tw-mb-6 tw-text-center">{{
        isModerator ? 'Sharing paused' : 'Paused'
      }}</strong>
    } @else if (isStopped) {
      <img
        src="/images/screen-sharing/screen-sharing-stopped.png"
        width="60"
        height="60"
        class="tw-mb-8"
        alt="Stopped"
      />
      <strong class="tw-text-3xl tw-font-semibold tw-mb-6 tw-text-center">{{
        isModerator ? 'Sharing stopped' : 'Stopped'
      }}</strong>
    } @else {
      <img
        src="/images/screen-sharing/screen-sharing-active.png"
        width="60"
        height="60"
        class="tw-mb-8"
        alt="Sharing"
      />
      <strong class="tw-text-3xl tw-font-semibold tw-mb-6 tw-text-center"
        >Sharing your screen</strong
      >
    }
    @if (isModerator) {
      <p class="tw-text-2xl tw-text-gray-600 tw-mb-6 tw-text-center">
        Your screen is being shared to the display.
      </p>
    }
  } @else if (isModerator) {
    @if (screenSharingService.sharing) {
      <initials-badge
        [name]="screenSharingService.sharing.memberDisplayName"
        [size]="80"
        class="tw-mb-6"
      ></initials-badge>
      <strong class="tw-text-3xl tw-font-semibold tw-mb-6 tw-text-center">
        {{ screenSharingService.sharing.memberDisplayName }} is sharing
      </strong>
      <p class="tw-text-2xl tw-text-gray-600 tw-mb-6 tw-text-center">
        You may invite another participant to share in their place.
      </p>
    } @else {
      <img
        src="/images/screen-sharing/user-circle-gray.png"
        width="60"
        height="60"
        class="tw-mb-8"
        alt="No User Sharing"
      />
      <strong class="tw-text-3xl tw-font-semibold tw-mb-6 tw-text-center"
        >No one is sharing</strong
      >
      <p class="tw-text-2xl tw-text-gray-600 tw-mb-6 tw-text-center">
        Select a participant to invite to share or share your screen.
      </p>
    }
  }

  @if (!isModerator) {
    @if (screenSharingService.channelError) {
      <div class="alert alert-danger">
        {{ screenSharingService.channelError }}
      </div>
    }
    <p class="tw-pb-2 tw-text-lg">
      @if (waiting) {
        <div class="moderator-list">
          To share your screen, you must be invited by
          <span [innerHTML]="moderatorName"></span>
        </div>
      } @else if (isPaused && screenSharingService.memberIsSharing) {
        Click "Resume" to resume screen sharing
      } @else if (isStopped) {
        Click "Start Sharing" to share your screen
      } @else {
        Your screen is being shared to the display
      }
    </p>
  }

  @if (!waiting) {
    <div class="tw-w-full tw-flex tw-flex-col tw-gap-4 tw-mt-5">
      @if (isStopped) {
        <button
          mat-flat-button
          color="primary"
          (click)="start()"
          [disabled]="
            screenSharingService.connecting &&
            !rvshareAppDetectionService.isScreenShareApp()
          "
        >
          @if (
            screenSharingService.connecting &&
            !rvshareAppDetectionService.isScreenShareApp()
          ) {
            <mat-spinner diameter="15" class="white"></mat-spinner>
          } @else if (isModerator) {
            Share now
          } @else {
            Start Sharing
          }
        </button>
      } @else {
        @if (canResumeSharing) {
          <button
            mat-flat-button
            color="primary"
            class="tw-w-full tw-text-2xl"
            (click)="resume()"
          >
            <mat-icon svgIcon="play-no-fill"></mat-icon>
            Resume Sharing
          </button>
        } @else if (
          screenSharingService.memberIsSharing &&
          !rvshareAppDetectionService.isScreenShareApp()
        ) {
          <button matButton="outlined" (click)="pause()">
            <mat-icon svgIcon="pause" aria-hidden="true"></mat-icon>
            Pause Sharing
          </button>
        }
        <button
          matButton="outlined"
          class="button-role--danger"
          (click)="stop()"
        >
          <mat-icon svgIcon="stop-circle" aria-hidden="true"></mat-icon>
          Stop Sharing
        </button>
      }
    </div>
    @if (
      !rvshareAppDetectionService.isScreenShareApp() &&
      (!screenSharingService.isModerated || screenSharingService.moderator) &&
      !isStopped
    ) {
      <div class="tw-w-full tw-mt-24">
        @if (screenSharingService.muted) {
          <div class="alert alert-warning">
            Audio is not supported on this display.
          </div>
        } @else {
          <div class="tw-mb-8">
            <strong class="tw-text-2xl tw-font-semibold tw-block tw-mb-4"
              >Video Volume</strong
            >
            <div class="tw-flex tw-items-center tw-gap-4">
              <mat-icon
                svgIcon="volume"
                class="tw-text-gray-600 large"
              ></mat-icon>
              <mat-slider
                min="0"
                max="100"
                step="1"
                color="accent"
                class="tw-flex-grow"
                [disabled]="screenSharingService.muted"
              >
                <input
                  matSliderThumb
                  [(value)]="screenSharingService.volume"
                  (valueChange)="changeVolume($event)"
                  aria-label="Volume control"
                />
              </mat-slider>
              <div class="volume tw-text-gray-900 tw-font-medium tw-text-xl">
                {{ screenSharingService.volume }}
              </div>
            </div>
          </div>
        }
        <div class="tw-mb-4">
          <strong class="tw-text-2xl tw-font-semibold tw-block tw-mb-4"
            >Video Quality</strong
          >
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            class="tw-w-full"
          >
            <mat-select
              name="videoQuality"
              [(ngModel)]="screenSharingService.quality"
              (selectionChange)="onChangeQuality($event)"
            >
              <mat-option value="high">High Quality</mat-option>
              <mat-option value="medium">Medium Quality</mat-option>
              <mat-option value="low">Low Quality</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
  }
</div>
